export var ERF_P = 0.3275911;
export var ERF_A1 = 0.254829592;
export var ERF_A2 = -0.284496736;
export var ERF_A3 = 1.421413741;
export var ERF_A4 = -1.453152027;
export var ERF_A5 = 1.061405429;
//# sourceMappingURL=erf_util.js.map